"use client";

import { useEffect, useState } from "react";

import { CookieConsentCategory, useCookieConsent } from "hooks/useCookieConsent";

export function CookieConsentProvider() {
  const necessary = useCookieConsent(CookieConsentCategory.necessary);
  const marketing = useCookieConsent(CookieConsentCategory.marketing);
  const statistical = useCookieConsent(CookieConsentCategory.statistical);

  const [prevNecessary, setPrevNecessary] = useState<boolean>(necessary);
  const [prevMarketing, setPrevMarketing] = useState<boolean>(marketing);
  const [prevStatistical, setPrevStatistical] = useState<boolean>(statistical);

  const [loadGtmScript, setLoadGtmScript] = useState<boolean>(false);

  useEffect(() => {
    if (marketing && statistical) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLoadGtmScript(true);
    }
  }, [marketing, statistical]);

  useEffect(() => {
    const revokedNecessary = !necessary && prevNecessary;
    const revokedMarketing = !marketing && prevMarketing;
    const revokedStatistical = !statistical && prevStatistical;

    if (revokedNecessary || revokedMarketing || revokedStatistical) {
      window.location.reload();
    }

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPrevNecessary(necessary);
    setPrevMarketing(marketing);
    setPrevStatistical(statistical);
  }, [necessary, marketing, statistical, prevNecessary, prevMarketing, prevStatistical]);

  useEffect(() => {
    if (loadGtmScript) {
      const script = document.createElement("script");
      script.src = "/gtm.js";
      script.async = true;
      document.head.appendChild(script);
    }
  }, [loadGtmScript]);

  return null;
}
